import { setServiceError } from "stores/settings";
import { LocalizationType } from "types/Catalogs";
import { api } from "utils/hostname";

export const fetchLocalization = async (
  lang: string,
): Promise<LocalizationType[] | undefined> => {
  try {
    const langISO = () => {
      if (lang === "ru") {
        return "rus";
      }
      return lang.toLowerCase();
    };

    const response = await api().get<LocalizationType[]>(
      `https://d8fdl9sb8v21s.cloudfront.net/Localizations/Localization+(${langISO()}).json`,
    );
    return response.data;
  } catch {
    setServiceError(true);
    return undefined;
  }
};
